export const AUTH_STATE_CHANGED_EVENT = 'guestbook-auth-state-changed';

const AUTH_STORAGE_KEYS = ['token', 'userEmail', 'userRole', 'userId'] as const;

let authExpiryRedirectInProgress = false;

export interface StoredAuthState {
  token: string | null;
  userEmail: string | null;
  userRole: string | null;
  userId: string | null;
}

export const getStoredAuthState = (): StoredAuthState => ({
  token: localStorage.getItem('token'),
  userEmail: localStorage.getItem('userEmail'),
  userRole: localStorage.getItem('userRole'),
  userId: localStorage.getItem('userId'),
});

export const isAuthenticated = (): boolean => Boolean(getStoredAuthState().token);

export const getToken = (): string => localStorage.getItem('token') || '';

export const notifyAuthStateChanged = () => {
  window.dispatchEvent(new Event(AUTH_STATE_CHANGED_EVENT));
};

export const setStoredAuthState = (data: {
  token: string;
  email: string;
  role: string;
  userId: string | number;
}) => {
  localStorage.setItem('token', data.token);
  localStorage.setItem('userEmail', data.email);
  localStorage.setItem('userRole', data.role);
  localStorage.setItem('userId', String(data.userId));
  authExpiryRedirectInProgress = false;
  notifyAuthStateChanged();
};

export const clearStoredAuthState = () => {
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  notifyAuthStateChanged();
};

export const handleExpiredSession = () => {
  if (!isAuthenticated() || authExpiryRedirectInProgress) {
    return;
  }

  authExpiryRedirectInProgress = true;
  clearStoredAuthState();

  const currentPath = window.location.pathname;
  if (currentPath !== '/login') {
    window.location.replace('/login');
  }
};

